import ReactECharts from "echarts-for-react";

const colors = [
  "#6F4E37",
  "#A67C52",
  "#C89B3C",
  "#8D6E63",
];

const sparkData = [
  [12, 18, 15, 22, 20, 27, 23],
  [25, 20, 23, 17, 19, 15, 13],
  [18, 24, 20, 22, 18, 16, 14],
  [10, 14, 12, 18, 16, 22, 30],
];

const formatAmount = (num = 0) => {
  if (num >= 1000000) return `${(num / 1000000).toFixed(1)}M`;
  if (num >= 1000) return `${(num / 1000).toFixed(1)}K`;
  return Number(num).toFixed(2);
};

const SparkLine = ({ data, color }) => {
  const option = {
    animation: false,
    grid: {
      left: 0,
      right: 0,
      top: 5,
      bottom: 5,
    },
    xAxis: {
      type: "category",
      show: false,
      data: data.map((_, i) => i),
    },
    yAxis: {
      type: "value",
      show: false,
    },
    series: [
      {
        type: "line",
        smooth: true,
        symbol: "none",
        data,
        lineStyle: {
          color,
          width: 3,
        },
        areaStyle: {
          opacity: 0.15,
          color,
        },
      },
    ],
  };

  return (
    <ReactECharts
      option={option}
      style={{
        width: 90,
        height: 45,
      }}
    />
  );
};

const CountrySalesCard = ({ data = [] }) => {
  const totalSale = data.reduce(
    (sum, item) => sum + (item.totalSales || 0),
    0
  );

  return (
    <div>
      <h3 className="fw-bold mb-1">Top Countries By Sales</h3>

      <p className="text-muted mb-4">
        Total Sale {formatAmount(totalSale)}
      </p>

      {data.length > 0 ? (
        data.map((item, index) => (
          <div
            key={item._id || index}
            className="d-flex align-items-center justify-content-between mb-4"
          >
            {/* Country */}
            <div style={{ width: "35%" }}>
              <span className="fw-semibold">
                {item.countryName}
              </span>
            </div>

            {/* Spark Line */}
            <SparkLine
              data={sparkData[index % sparkData.length]}
              color={colors[index % colors.length]}
            />

            {/* Sales */}
            <div
              className="fw-bold text-end"
              style={{ width: 70 }}
            >
              {formatAmount(item.totalSales)}
            </div>
          </div>
        ))
      ) : (
        <div className="text-center text-muted py-5">
          No country sales found.
        </div>
      )}
    </div>
  );
};

export default CountrySalesCard;